module.exports = __webpack_public_path__ + "img/qrCode.82f0263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/qrCode.jpg
// module id = 359
// module chunks = 0